export { default as default } from './Text';
